import auth0 from 'auth0-js';
import { createActions } from 'redux-actions';
import { call, select } from 'redux-saga/effects';
import { redirectAuth0 } from '../../../../remote-apis';
import { auth0ConfigSelector } from '../../configuration/selectors';

const actions = createActions({
  SESSION: {
    LOGIN: (invitationToken, customRedirect) => ({ invitationToken, customRedirect }),
    API: {
      LOGIN: {
        REQUEST: undefined,
        SUCCESS: (idToken) => ({ idToken }),
        FAILED: (error) => ({ error })
      }
    }
  }
})

export function* login(action) {
  const auth0Config = yield select(auth0ConfigSelector);
  const webAuth = new auth0.WebAuth({
    clientID: auth0Config.clientId,
    domain: auth0Config.domain
  });

  const { invitationToken, customRedirect } = action.payload;

  yield call(redirectAuth0, invitationToken, customRedirect, webAuth, auth0Config.realm);
}

const configuration = {
  name: 'login',
  action: actions,
  sagas: login,
  reducers: {
    request: (state, action) => ({
      ...state,
      isLoggingIn: true,
      isLoggingOut: false,
      message: null
    }),
    failed: (state, { payload: { error } }) => ({
      ...state,
      isLoggingIn: false,
      isLoggingOut: false,
      isAuthenticated: false,
      userId: null,
      idToken: null,
      message: error
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/login.js